// extracted by mini-css-extract-plugin
export default {"close":"modal_close__xJ7Bc","closeR":"modal_closeR__vZtbD","close_button":"modal_close_button__Kxwrk"};